<template>

	<ChangePassword style="margin-top: -20px;" page="lostpassword"></ChangePassword>

</template>

<script>

import ChangePassword from '@components/ChangePassword';

export default {
	components: {
		ChangePassword
	}
};

</script>
